/**
 * Urologie — specialty manifest.
 *
 * Maintained through the Specialty Registry. The manifest is data: the shell
 * reads it and knows nothing about this specialty.
 *
 * Legacy codes resolved here: URO
 * Catalogue acts (NGAP Maroc): 187
 */
import { defineSpecialty } from "../types";

export const urologie = defineSpecialty(
{
  "id": "urologie",
  "label": "Urologie",
  "short": "Urologie",
  "scope": "Appareil urinaire et génital masculin",
  "aliases": [
    "URO"
  ],
  "doctorSpecs": [
    "Urologie"
  ],
  "featureFlag": "ux.v2.urologie",
  "theme": {
    "primary": "oklch(0.69 0.13 200)",
    "primaryForeground": "oklch(0.98 0.005 240)",
    "accent": "oklch(0.78 0.16 80)",
    "accentForeground": "oklch(0.18 0.02 240)",
    "destructive": "oklch(0.65 0.22 27)",
    "success": "oklch(0.78 0.18 150)",
    "warning": "oklch(0.78 0.16 80)",
    "surface": "oklch(0.205 0.006 240)",
    "radius": "0.75rem",
    "fontDisplay": "\"Inter\", ui-sans-serif, system-ui, sans-serif"
  },
  "navigation": [
    {
      "id": "consult",
      "label": "Consultation",
      "icon": "Stethoscope",
      "route": "/clinical/consult",
      "order": 1,
      "requires": []
    },
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "route": "/clinical/imaging",
      "order": 2,
      "requires": [
        "imaging"
      ]
    },
    {
      "id": "endoscopy",
      "label": "Endoscopie",
      "icon": "Scan",
      "route": "/clinical/endoscopy",
      "order": 3,
      "requires": []
    },
    {
      "id": "prescription",
      "label": "Ordonnance",
      "icon": "Pill",
      "route": "/clinical/prescription",
      "order": 4,
      "requires": []
    },
    {
      "id": "billing",
      "label": "Cotations",
      "icon": "Receipt",
      "route": "/clinical/billing",
      "order": 5,
      "requires": []
    }
  ],
  "panels": [
    {
      "id": "imaging",
      "label": "Imagerie",
      "icon": "Image",
      "component": "ClinicalImageGallery",
      "order": 1,
      "requires": []
    },
    {
      "id": "timeline",
      "label": "Chronologie",
      "icon": "History",
      "component": "PatientTimeline",
      "order": 2,
      "requires": []
    }
  ],
  "ngap": {
    "specialtyScope": "Urologie",
    "subSpecialties": [
      "Consultation",
      "Cystoscopie",
      "Lithotritie",
      "Résection"
    ],
    "catalogueActs": 187
  },
  "terminology": {
    "icd10": [
      "N20",
      "N40",
      "N60",
      "N83"
    ],
    "loinc": [
      "57495-5",
      "19201-3"
    ],
    "snomed": []
  },
  "deviceProfiles": [
    "cystoscope",
    "ultrasound-renal",
    "uroflowmeter"
  ],
  "locales": [
    "fr",
    "ar"
  ]
}
);

export default urologie;
